export const locale = {
  lang: 'vn',
  data: {
    DOWNLOAD: 'Tải Xuống',
    REMOVE: 'Xoá',
    NOT_SUPPORT: 'Hệ thống chưa hỗ trợ xem trước loại tệp này. Vui lòng tải xuống để xem.',
    NOT_SUPPORT_WHEN_TYPING: 'Hệ thống chưa hỗ trợ xem trước loại tệp này.',
    AT: 'lúc',
  },
};
